import { useId } from "react";
import type { AnchorRect } from "../../utils/anchoredPosition";

/** Space between the anchor's edge and the edge of the cutout. */
export const SPOTLIGHT_PADDING = 6;

interface TourSpotlightProps {
  rect: AnchorRect | null;
}

/**
 * The dimmed page with a rounded cutout over the anchor. Decorative: hidden from assistive tech,
 * which gets the step from the bubble instead. With no rect the whole page is dimmed.
 */
export const TourSpotlight = ({ rect }: TourSpotlightProps) => {
  // useId output contains characters that are not valid inside url(#...).
  const maskId = `tour-mask-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;

  return (
    <svg className="tour-spotlight" aria-hidden="true" focusable="false">
      <defs>
        <mask id={maskId}>
          {/* Mask luminance, not theme colour: white keeps the shade, black cuts it out. */}
          <rect width="100%" height="100%" fill="white" />
          {rect && (
            <rect
              className="tour-spotlight__cutout"
              x={rect.left - SPOTLIGHT_PADDING}
              y={rect.top - SPOTLIGHT_PADDING}
              width={rect.width + SPOTLIGHT_PADDING * 2}
              height={rect.height + SPOTLIGHT_PADDING * 2}
              fill="black"
            />
          )}
        </mask>
      </defs>
      <rect
        className="tour-spotlight__shade"
        width="100%"
        height="100%"
        mask={`url(#${maskId})`}
      />
    </svg>
  );
};
